module.exports = __webpack_public_path__ + "static/media/logo-wx3.b68d05da.svg";